import React, { useContext, useEffect } from 'react';
import AppContext from 'context/Context';
import { Navigate, Route, Routes } from 'react-router-dom';
import is from 'is_js';
import MainLayout from './MainLayout';
// import SettingsToggle from 'components/settings-panel/SettingsToggle';
// import SettingsPanel from 'components/settings-panel/SettingsPanel';
import ErrorLayout from './ErrorLayout';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';

import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import Dashboard from 'components/dashboards';
import Donors from 'components/donar';
import CreateDonar from 'components/donar/CreateDonar';
import DonorLayout from '../components/donar-details/DonorLayout';
import AddDonation from 'components/add-donation';
import PayNow from 'components/add-donation/PayNow';
import AllBeneficiaries from 'components/beneficiaries';
import UnSponsoredList from 'components/beneficiaries/UnSponsoredList';
import SponsoredList from 'components/beneficiaries/SponsoredList';
import ProjectsKanban from 'components/projects';
import ProjectsList from 'components/projects/ProjectsList';
import CreateProject from 'components/projects/CreateProject';
import ProjectLayout from 'components/projects/ProjectLayout';
import ProjectProgressList from 'components/projects/ProjectProgressList';
import CreateNewSponsor from 'components/donar-details/CreateNewSponsor';
import CreateNewSponsorFrom from 'components/donar-details/CreateNewSponsorFrom';
import Home from 'components/Home';

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <>
      <Routes>
        <Route element={<ErrorLayout />}>
          <Route path="errors/404" element={<Error404 />} />
          <Route path="errors/500" element={<Error500 />} />
        </Route>

        <Route element={<Home />} path="home" />

        <Route element={<MainLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/donors" element={<Donors />} />
          <Route path="/donors/:id/*" element={<DonorLayout />} />
          <Route path="/donors/:id/sponsor" element={<CreateNewSponsor />} />
          <Route
            path="/donors/:id/sponsor/from"
            element={<CreateNewSponsorFrom />}
          />
          <Route
            path="/donors/:id/sponsor/from/:sponsorId"
            element={<CreateNewSponsorFrom />}
          />
          <Route path="/donors/add-new-donar" element={<CreateDonar />} />
          <Route path="/add-new-donation" element={<AddDonation />} />
          <Route path="/pay_now" element={<PayNow />} />
          <Route path="/beneficiaries" element={<AllBeneficiaries />} />
          <Route
            path="/beneficiaries/sponsored_list"
            element={<SponsoredList />}
          />
          <Route
            path="/beneficiaries/unsponsored_list"
            element={<UnSponsoredList />}
          />
          <Route path="/project/kanban" element={<ProjectsKanban />} />
          <Route path="/project/list" element={<ProjectsList />} />
          <Route path="/project/create_project" element={<CreateProject />} />
          <Route path="project" element={<Navigate to="kanban" replace />} />
          <Route
            path="/project/:id/progress"
            element={<ProjectProgressList />}
          />
          <Route path="/project/details/:id/*" element={<ProjectLayout />} />
        </Route>

        <Route path="*" element={<Navigate to="/errors/404" replace />} />
      </Routes>
      {/* <SettingsToggle />
      <SettingsPanel /> */}
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </>
  );
};

export default Layout;
